import React, {useEffect, useMemo} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Card, Colors, H3, Icon, Spinner} from '@blueprintjs/core';
import {IconNames} from '@blueprintjs/icons';

import {IState} from '../../shared/store/reducers';
import {ApiStatus} from '../../shared/models';
import {loadWorkflows, unsetWorkflows} from '../../shared/store/actions/workflowActions';
import TriggerDialogContainer from '../../shared/components/dialogs/Trigger';
import ScheduleElement from './ScheduleElement';

const Loading = () => (
  <>
    <div className="home__content__block__item ">
      <div className="home__content__block__item__name block-loading bp4-skeleton" />
    </div>
    <div className="home__content__block__item ">
      <div className="home__content__block__item__name block-loading bp4-skeleton" />
    </div>
    <div className="home__content__block__item ">
      <div className="home__content__block__item__name block-loading bp4-skeleton" />
    </div>
  </>
);

const SchedulesList = () => {
  const workflows = useSelector((state: IState) => state.workflows.workflows);
  const loadingStatus = useSelector((state: IState) => state.workflows.loadingListStatus);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(loadWorkflows(true));
    return () => {
      dispatch(unsetWorkflows());
    };
  }, []);

  const filteredWorkflows = useMemo(
    () => workflows.filter((w: any) => {
      /*
       * Workflow should have next run, and it should not be older than 1 day (24 hours) because of TZ issues
       */
      return (
        w.next_run &&
        new Date(w.next_run).getTime() > (Date.now() - (24 * 60 * 60 * 1000))
      );
    }), [workflows]);
  const sortedWorkflows = useMemo(
    () => filteredWorkflows.sort((a: any, b: any) => {
      return new Date(a.next_run).getTime() - new Date(b.next_run).getTime();
    }), [filteredWorkflows]);

  return (
    <>
      <div className="home__content__block">
        <div className="home__content__block__header schedule-list">
          <div className="home__content__block__header__left">
            <Icon
              icon={IconNames.CALENDAR}
              size={18}
              color={Colors.GRAY3}
              className="home__content__block__header__icon"
            />
            Active Schedules
          </div>
        </div>
        <Card className="home__content__block__card">
          <div className="home__content__block__list">
            {loadingStatus === ApiStatus.LOADING ? (
              <Loading />
            ) : (
              sortedWorkflows.length > 0 ? (
                <>
                  {
                    sortedWorkflows.map((schedule: any) => (
                      <ScheduleElement key={schedule.id} schedule={schedule} />
                    ))
                  }
                </>
              ) : (
                <div className="home__content__block__nodata">
                  <Icon icon={IconNames.CALENDAR} color={Colors.GRAY3} size={60} />
                  <H3>No Active Schedules</H3>
                  <p>Schedule a Report to create your first automation</p>
                </div>
              )
            )}
          </div>
        </Card>
      </div>
      <TriggerDialogContainer
        triggerProps={{
          showTriggerType: false,
        }}
      />
    </>
  );
};

export default SchedulesList;
